import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import styles from './PartnersFounders.module.css';
import Eyebrow from '../ui/Eyebrow';

export default function PartnersFounders() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.12 });

  return (
    <section className={styles.split} id="partners" ref={ref}>
      <motion.div
        className={styles.container}
        initial={{ opacity: 0, y: 16 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.5 }}
      >
        <div className={styles.panel} id="partners-panel">
          <Eyebrow>PARTNER CAPITAL</Eyebrow>
          <h2 className={styles.heading}>Partner capital. Portfolio exposure.</h2>
          <div className={styles.body}>
            <p>Infundra offers partners a single entry point into a diversified portfolio of AI-native B2B companies, without the binary risk profile of a single-product investment. By investing in the platform entity, partners hold a pro-rata interest in the founding equity stake Infundra takes in each portfolio company at inception. Capital is raised in structured tranches tied to defined de-risking milestones.</p>
            <p>This is a long-duration position structured for partners whose investment horizon aligns with the compounding logic of the model. Patient capital. Built to compound.</p>
          </div>
        </div>

        <div className={styles.divider} />

        <div className={styles.panel} id="founders">
          <Eyebrow>FOR FOUNDERS</Eyebrow>
          <h2 className={styles.heading}>For domain founders.</h2>
          <div className={styles.body}>
            <p>Infundra partners with operators who possess deep domain expertise and the full-time commitment to build a category-defining company, without spending twelve months rebuilding foundational infrastructure. Portfolio founders receive day-one access to a fully integrated, multi-layered technology stack and a compliance posture advancing toward SOC 2 Type 1 certification.</p>
            <p>Infundra holds a founding equity stake at formation. The founder retains majority ownership and operational control. If the opportunity is clear and the infrastructure has been the barrier, we should speak.</p>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
